export const standardRenewalStats = () => [
        {
            "id": "activeAccounts",
            "tab": "renewal",
            "visible": true,
            "order": 1,
            "voiceover": "This chart shows the number of upsell transactions.",
            link: "#activeAccounts",
            title: "Active Accounts",
            "props": {
                "chartTitle": "Active Accounts",
                "chartDescription": `This chart estimates the total number of active
                                accounts {segmentDescription}`,
                "chartColorId": "active accounts",
                "inputType": "integer",
                "legendLabel": "Active Accounts",
                "bottomLegendLabel": "Month Ending",
                // "trendLineEntry": "Active Accounts",
                // "handleChartClick": "handleTransactionsChartClick",
                "usedInPredictions": false,
                "availableGlobalOnly": false,
                "drilldownAvailable": false,
                groupOrStacked: 'stacked',
                showMarkers: false,
                isDistroChart: false,
                isComposed: false,
            }
        }






        // showDescriptionsInMainView={showDescriptionsInMainView}
        //                                    recentColorOverrides={recentColorOverrides}
        //                                    resetAllColorOverrides={resetAllColorOverrides}
        //                                    customColorOverrides={customColorOverrides}
        //                                    handleCustomColorOverrides={handleCustomColorOverrides}
        //                                    chartDescription={`This chart estimates the total number of active
        //                        accounts ${segment === 'default' ? `globally across ${currUser.companyName}.` : customQueryOptions && customQueryOptions.length > 0 && " in the " + segmentName + " segment."}`}
        //                                    segmentName={segmentName}
        //                                    gtmStatDrawerOpen={gtmStatDrawerOpen}
        //                                    drawerHeight={drawerHeight}
        //                                    handleMakeChartFullScreen={handleMakeChartFullScreen}
        //                                    chartTitle={"active accounts"}
        //                                    chartColorId={"active accounts"}
        //                                    chartTitleSegment={`${segment} active accounts`}
        //                                    fullScreenMode={fullScreenMode}
        //
        //                                    groupByQuarter={groupByQuarter}
        //                                    effectiveDateRange={effectiveDateRange}
        //                                    currQuarterString={currQuarterString}
        //                                    currMonthString={currMonthString}
        //                                    defaultColors={defaultColors}
        //                                    chartData={groupByQuarter ? activeAccountTimeSeries : activeAccountTimeSeries}
        //                                    inputType={'integer'}
        //                                    dateType={groupByQuarter ? 'Month' : 'Month'}
        //                                    bottomLegendLabel={"Month Ending"}
        //
        //                                    showMarkers={false}
        //                                    legendLabel={"Active Accounts"}
        //                                    chartKeys={['Active Accounts']}

    ]